import { Controller } from "@hotwired/stimulus"
import StartToastifyInstance from "toastify-js";

export default class extends Controller {
  static targets = ["files"]

  validate(event) {
    this.filesTargets.forEach((target) => {
      if (target.files.length == 0) {
        event.preventDefault();
        StartToastifyInstance({
          text: `Selecione ao menos um arquivo para ${target.dataset.document}.`,
          duration: 3000,
          close: true,
          gravity: "bottom",
          position: "center",
          backgroundColor: "#ff0000",
          stopOnFocus: true,
        }).showToast();
        return;
      } 
    });
  }
}